<template>
    <div class="container profile pb-5">
        <div class="row pt-4">
            <div class="col-12">
                <h2 class="font-weight-bold profile__header">
                    Company
                </h2>
            </div>
            <div class="col-12">
                <p class="profile__desc">
                    Here's a preview of your company profile.
                </p>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <company-profile-detail
                    :company="company"
                    :remote_measures="remote_measures"
                ></company-profile-detail>
            </div>
        </div>
    </div>
</template>

<script>
import CompanyState from "./NewCompanyState";
import DropdownOptionsConfig from "./DropdownOptionsConfig";

export default {
    data() {
        return {
            company: CompanyState.company,
            remote_measures: CompanyState.remote_measures,
            current_user: {
                role: {
                    slug: ""
                }
            }
        };
    },

    methods: {
        async getCurrentUserCompany() {
            const res = await axios.get("get-user-company");
            const data = res.data.data;
            this.company.name = data.name;
            this.company.employee_count = data.employee_count;
            this.company.country = data.country;
            this.company.city = data.city;
            this.company.other_remarks = data.other_remarks;
            this.company.logo_src = data.logo_src;
            this.company.offices = data.offices;

            Object.keys(DropdownOptionsConfig.wfhOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.wfhOptions[key] ===
                    data.allow_work_from_home
                ) {
                    this.company.work_from_home = key;
                }
            });

            Object.keys(DropdownOptionsConfig.travelOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.travelOptions[key] ===
                    data.allow_travel
                ) {
                    this.company.travel = key;
                }
            });

            Object.keys(DropdownOptionsConfig.visitorOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.visitorOptions[key] ===
                    data.allow_visitors
                ) {
                    this.company.visitors = key;
                }
            });

            Object.keys(DropdownOptionsConfig.eventsOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.eventsOptions[key] ===
                    data.allow_events
                ) {
                    this.company.events = key;
                }
            });
        },

        async getRemoteFriendliness() {
            const res = await axios.get("company-remote-friendliness");
            const data = res.data.data;
            this.remote_measures.video_conference =
                data.uses_video_conference_tools === 1;
            this.remote_measures.project_management =
                data.uses_project_management_tools === 1;
            this.remote_measures.clear_sop = data.has_clear_sops === 1;
            this.remote_measures.set_communications_protocol =
                data.set_communications_protocol === 1;
            this.remote_measures.help_remote_ready =
                data.needs_help_remote_ready === 1;
            this.remote_measures.schedule_regular_scrums =
                data.schedule_regular_scrums === 1;
            this.remote_measures.uses_git = data.uses_git === 1;
            this.remote_measures.has_tech_team = data.has_tech_team === 1;
        },

        async getCurrentUser() {
            const data = await axios.get("me");
            this.current_user = data.data.data;
        }
    },

    mounted() {
        this.getCurrentUserCompany();
        this.getRemoteFriendliness();
        this.getCurrentUser();
    }
};
</script>

<style lang="scss" scoped>
.profile {
    &__header {
        color: #303030;
        font-family: Lato;
        font-size: 38px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 60px;
        text-align: center;

        @media (max-width: 768px) {
            text-align: left;
        }
    }

    &__desc {
        color: #606064;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;

        @media (max-width: 768px) {
            text-align: left;
        }
    }
}
</style>
